<template>
  <v-content class="candidate documents page">
    <v-container>
      <v-card>
        <v-card-title class="headline">
          My Documents
        </v-card-title>
        <v-divider />
        <div class="mb-3">&nbsp;</div>
        <MyDocumentsSection :profile="profile" />
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
// Components
import MyDocumentsSection from '@/components/candidate/profile/edit/MyDocumentsSection'

// Helpers
import { mapGetters } from 'vuex'

export default {
  components: { MyDocumentsSection },
  created() {
    this.$store.dispatch('candidate/profile/fetch')
  },
  computed: mapGetters({
    profile: 'candidate/profile/model',
  }),
}
</script>